import React from 'react';
import { motion } from 'framer-motion';
import { Shield, DollarSign, Rocket, TrendingUp, Target, Zap } from 'lucide-react';
export function WhyInvestSlide() {
  const points = [{
    icon: Shield,
    title: 'Strong Defensibility',
    desc: 'AI-native + vertical moat + codified pharma expertise & intelligence',
    bg: 'bg-purple-50',
    border: 'border-purple-200',
    iconBg: 'bg-purple-100',
    iconColor: 'text-purple-600'
  }, {
    icon: DollarSign,
    title: 'Premium Multiples',
    desc: 'Outcome model = premium multiples, low churn',
    bg: 'bg-green-50',
    border: 'border-green-200',
    iconBg: 'bg-green-100',
    iconColor: 'text-green-600'
  }, {
    icon: Rocket,
    title: 'Real Momentum',
    desc: 'Pipeline + traction = real momentum',
    bg: 'bg-amber-50',
    border: 'border-amber-200',
    iconBg: 'bg-amber-100',
    iconColor: 'text-amber-600'
  }, {
    icon: TrendingUp,
    title: '25% YoY Growth',
    desc: 'Strong SaS growth 25% YoY — market tailwind accelerating',
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    iconBg: 'bg-blue-100',
    iconColor: 'text-blue-600'
  }, {
    icon: Target,
    title: 'Category Leader',
    desc: 'Clear the table in regulated HCP communication',
    bg: 'bg-indigo-50',
    border: 'border-indigo-200',
    iconBg: 'bg-indigo-100',
    iconColor: 'text-indigo-600'
  }, {
    icon: Zap,
    title: 'Perfect Inflection',
    desc: 'SaaS reset + agentic AI maturity = NOW.',
    bg: 'bg-rose-50',
    border: 'border-rose-200',
    iconBg: 'bg-rose-100',
    iconColor: 'text-rose-600'
  }];
  return <div className="h-full flex flex-col relative overflow-hidden" data-id="element-568">
      {/* Header */}
      <motion.div initial={{
      opacity: 0,
      y: 15
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-8" data-id="element-569">
        <p className="text-sm font-medium text-purple-600 uppercase tracking-wider mb-1" data-id="element-570">
          Why Invest?
        </p>
        <h2 className="text-4xl font-bold text-gray-900" data-id="element-571">
          Asymmetric Opportunity
        </h2>
      </motion.div>

      {/* Points grid */}
      <div className="flex-1 flex flex-col justify-center" data-id="element-572">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-5xl" data-id="element-573">
          {points.map((point, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 15
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.15 + idx * 0.1
        }} className={`flex items-center gap-4 p-5 rounded-xl ${point.bg} border ${point.border}`} data-id="element-574">
              <div className={`w-11 h-11 rounded-lg ${point.iconBg} flex items-center justify-center shrink-0`} data-id="element-575">
                <point.icon className={`w-5 h-5 ${point.iconColor}`} data-id="element-576" />
              </div>
              <div data-id="element-577">
                <h3 className="text-base font-bold text-gray-900" data-id="element-578">
                  {point.title}
                </h3>
                <p className="text-sm text-gray-500 mt-0.5" data-id="element-579">{point.desc}</p>
              </div>
            </motion.div>)}
        </div>
      </div>

      {/* Bottom callout banner */}
      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.8
    }} className="mt-auto" data-id="element-580">
        <div className="bg-purple-600 rounded-xl px-8 py-5 flex items-center justify-between" data-id="element-581">
          <p className="text-white font-bold text-lg tracking-tight" data-id="element-582">
            "We are positioned to become the standard."
          </p>
          <div className="text-purple-200 text-sm font-mono hidden md:block" data-id="element-583">
            snakker
          </div>
        </div>
      </motion.div>

      {/* Decorative upward curve — bottom right */}
      <svg className="absolute bottom-0 right-0 w-[220px] h-[180px] opacity-10 pointer-events-none" viewBox="0 0 220 180" fill="none" data-id="element-584">
        <motion.path d="M220 180 C 180 160, 140 120, 120 80 C 100 40, 60 15, 0 5" stroke="#7C3AED" strokeWidth="3" strokeLinecap="round" fill="none" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 1.5,
        delay: 0.5
      }} data-id="element-585" />
        <motion.path d="M220 180 C 180 160, 140 120, 120 80 C 100 40, 60 15, 0 5" stroke="#7C3AED" strokeWidth="16" strokeOpacity="0.3" strokeLinecap="round" fill="none" initial={{
        pathLength: 0
      }} animate={{
        pathLength: 1
      }} transition={{
        duration: 1.5,
        delay: 0.5
      }} data-id="element-586" />
      </svg>
    </div>;
}